




























import ApiClient from '@/common/api'
import Global from '@/common/global.js'
import store from '@/store'
import SearchYear from '@/views/organisms/SearchYear.vue'

export default
  components: {
    ApiClient
    SearchYear
  }

  data: () ->
    collectSystemColor: Global.collectSystemColor()
    meter: []
    collectSystem: Global.collectSystem()

  created: () ->
    store.dispatch('initPostParam')
    date = new Date();
    @year = date.getFullYear()
    @getCollectSystem(@year)

  methods: {
    backgroundColor: (id) ->
      for row, index in @collectSystemColor
        if row.id == id
          return row.color
      return 'background-color: #2d287f;'
    yearSearch: (e) ->
      @year = e.year
      @getCollectSystem(e.year)
    getCollectSystem: (year) ->
      api = new ApiClient()
      data = await api.get('/admin/collect_system/list/' + year)
      @meter = data.list
    returnCollectSystemName: (id) ->
      for row, index in @collectSystem
        if row.id == id
          return row.name
      return '合計'
  }
